import { z } from "zod";
// https://docs.aws.amazon.com/marketplace/latest/APIReference/API_marketplace-metering_ResolveCustomer.html#API_marketplace-metering_ResolveCustomer_ResponseElements
export const customerDataSchema = z.object({
    customerIdentifier: z.string({
        required_error: 'Customer identifier is required.',
        invalid_type_error: 'Customer identifier must be a string.'
    }).min(0, 'Customer identifier must be at least 0 characters long.').max(255, 'Customer identifier must not exceed 255 characters.').regex(/[\s\S]*/, 'Customer identifier must be in a valid format.'),
    customerAWSAccountID: z.string({
        required_error: 'AWS Account ID is required.',
        invalid_type_error: 'AWS Account ID must be a string.'
    }).min(1, 'AWS Account ID must be at least 1 character long.').max(255, 'AWS Account ID must not exceed 255 characters.').regex(/^[0-9]+$/, 'AWS Account ID must contain only digits.'),
    productCode: z.string({
        required_error: 'Product code is required.',
        invalid_type_error: 'Product code must be a string.'
    }).min(1, 'Product code must be at least 1 character long.').max(255, 'Product code must not exceed 255 characters.').regex(/^[-a-zA-Z0-9/=:_.@]*$/, 'Product code must contain only valid characters.'),
    usagePlanId: z.string({
        required_error: 'Usage Plan Id is required.',
        invalid_type_error: 'Usage Plan Id must be a string.'
    }).min(1, 'Usage Plan Id must be at least 1 character long.').max(255, 'Usage Plan Id must not exceed 255 characters.').regex(/^[-a-zA-Z0-9/=:_.@]*$/, 'Usage Plan Id must contain only valid characters.').optional()
});
// https://docs.aws.amazon.com/marketplace/latest/APIReference/API_marketplace-entitlements_Entitlement.html
export const entitlementSchema = z.object({
    ProductCode: customerDataSchema.shape.productCode,
    Dimension: z.string(),
    CustomerIdentifier: customerDataSchema.shape.customerIdentifier,
    CustomerAWSAccountId: customerDataSchema.shape.customerAWSAccountID,
    ExpirationDate: z.date(),
    Value: z.object({
        IntegerValue: z.number().optional(),
        DoubleValue: z.number().optional(),
        BooleanValue: z.boolean().optional(),
        StringValue: z.string().optional()
    }).optional()
});
// https://docs.aws.amazon.com/marketplace/latest/APIReference/API_marketplace-entitlements_GetEntitlements.html
export const entitlementsSchema = z.array(entitlementSchema);
// https://docs.aws.amazon.com/marketplace/latest/APIReference/API_marketplace-metering_ResolveCustomer.html#API_marketplace-metering_ResolveCustomer_RequestParameters
export const marketplaceTokenSchema = z.string({
    required_error: 'Marketplace token is required.',
    invalid_type_error: 'Marketplace token must be a string.'
}).regex(/[\s\S]+/, {
    message: 'Invalid marketplace token format.'
});
// AWS Marketplace entitlement notification schema
// https://docs.aws.amazon.com/marketplace/latest/userguide/saas-notification.html#saas-sns-message-body
export const entitlementNotificationSchema = z.object({
    action: z.literal('entitlement-updated'),
    'customer-identifier': customerDataSchema.shape.customerIdentifier,
    'product-code': customerDataSchema.shape.productCode
});
export const subscriptionMigrationMessageSchema = z.union([
    z.object({
        action: z.literal('delete'),
        apiKeyId: z.string(),
        usagePlanIds: z.array(z.string())
    }),
    z.object({
        action: z.literal('update'),
        apiKeyId: z.string(),
        oldUsagePlanIds: z.array(z.string()),
        newUsagePlanIds: z.array(z.string())
    })
]);
